import {
	deselectOrderId,
	selectOrderDetail,
	useOrderInfo,
	useOrderState,
} from 'entities/orders';
import React, { FC, useEffect } from 'react';
import { usePaginationFilter } from 'shared/lib/pagination';
import { PaginationHook } from 'shared/lib/pagination';
import { useAppDispatch, useAppSelector } from 'shared/lib/store';
import { GridTable } from 'shared/ui/gridTable';
import { GridTableProps } from 'shared/ui/gridTable/types';

export const OrderGridTable: FC<
	Omit<
		GridTableProps,
		'onClickOnCard' | 'selectedRowId' | 'onScrollEnd' | 'isLoadingBottom'
	>
> = props => {
	const dispatch = useAppDispatch();
	const { loadMore, isLoading, isLoadingMore } =
		usePaginationFilter() as PaginationHook;
	const { close, isOpen } = useOrderInfo();
	const order = useAppSelector(selectOrderDetail);

	const { isWaitingList } = useOrderState(order);

	useEffect(() => {
		if (!isOpen && !isWaitingList) {
			props.setCurrentRowId?.(undefined);
			dispatch(deselectOrderId());
		}
		// eslint-disable-next-line
	}, [isOpen, dispatch, isWaitingList]);

	useEffect(() => {
		if (props.tableRows && !isWaitingList) {
			props.setCurrentRowId?.(undefined);
			// close();
			dispatch(deselectOrderId());
		}
		// eslint-disable-next-line
	}, [props.tableRows, dispatch, close, isWaitingList]);

	return (
		<GridTable
			onClickOnCard={props.selectOrder}
			selectedRowId={props.currentRowId}
			onScrollEnd={loadMore}
			isLoadingBottom={isLoadingMore}
			isLoading={isLoading && !isLoadingMore}
			{...props}
		/>
	);
};

export const OrderGridTableMemoized = React.memo(OrderGridTable)